import { render, staticRenderFns } from "./retarget.vue?vue&type=template&id=33b750f4&scoped=true"
import script from "./retarget.vue?vue&type=script&lang=js"
export * from "./retarget.vue?vue&type=script&lang=js"
import style0 from "./retarget.vue?vue&type=style&index=0&id=33b750f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b750f4",
  null
  
)

export default component.exports